<div class="container-fluid">
  <app-content-tab-list activeTab="0" type="entities" category="Entities"></app-content-tab-list>
  <div class="row section1 mt-4 align-items-center">
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="home-details">
        <h5 class="home-title">Entities</h5>
        <p class="home-subtitle">List of all Entities</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="dashboard-btn dashboard-manage">
        <app-import-data-modal kind="entities"></app-import-data-modal>
        <app-import-data-modal kind="entityLookup"></app-import-data-modal>
        <div>
          <a routerLink="/entities/create-entity">
            <button class="btn btn-primary btn-dashboard mt-2">
              <i class="las la-plus"></i>Create new Entity
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="row section1">
    <div class="col-12">
      <div class="entities-filters-card">
        <div class="entities-filters-title">Filter Entities</div>
        <div class="entities-filters-grid">
          <div class="entities-filter-item entities-filter-item-wide">
            <label class="entities-filter-label">Keyword</label>
            <input type="text"
              class="form-control"
              [(ngModel)]="filters.keyword"
              (keydown)="handleFilterInputKeyDown($event)"
              placeholder="Name, slug or entity id"/>
          </div>
          <div class="entities-filter-item">
            <label class="entities-filter-label">Category</label>
            <select class="form-control" [(ngModel)]="filters.category">
              @for (c of categories; track c) {
                <option [value]="c.id">{{c.categoryName}}</option>
              }
            </select>
          </div>
          <div class="entities-filter-item">
            <label class="entities-filter-label">Is Person</label>
            <select class="form-control" [(ngModel)]="filters.inPerson">
              <option value="all">All</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
          <div class="entities-filter-item">
            <label class="entities-filter-label">Sort By</label>
            <select class="form-control" [(ngModel)]="filters.sortBy">
              <option value="created_desc">Latest created</option>
              <option value="created_asc">Oldest created</option>
              <option value="name_asc">Name (A-Z)</option>
              <option value="name_desc">Name (Z-A)</option>
            </select>
          </div>
          <div class="entities-filter-actions">
            <button class="btn entities-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-----------user table------------------>
  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Image</th>
              <th scope="col">Full Name</th>
              <th scope="col">Is Person ?</th>
              <th scope="col">Category</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && !!users?.length) {
            <tbody>
              @for (user of users | paginate: {itemsPerPage: perPage, currentPage: page, totalItems: total}; track user; let i = $index) {
                <tr class="client"
                  >
                  <td class="text-nowrap" [attr.title]="(user.id || '').toUpperCase()"><span>{{(user.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(user.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td><img [src]="user.image" alt="entity-image" width="75" height="75"></td>
                <td>{{user.firstName ? (user.firstName + ' ' + user.lastName) : user.slug }}</td>
                <td [ngClass]="user.in_person ? 'text-success' : 'text-danger'">{{ user.in_person ? 'Yes' : 'No' }}</td>
                <td>{{getCategoryName(user.category)}}</td>
                <td>{{ user.createdAt | date : 'mediumDate' }}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="   mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                          [routerLink]="['/entities/single-entity/', user.id]">
                          <i class="las la-eye mb-1 la-lg  align-middle mr-0"></i> View</a>
                          <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                            [routerLink]="['/entities/edit-entity/', user.id]">
                            <i class="las la-edit mb-1 la-lg align-middle mr-0"></i> Edit</a>
                            <a class=" dropdown-item  text-primary border-bottom py-2 text-nowrap"
                              [routerLink]="['/entities/review-entity/', user.id]">
                              <i class="las la-comment mb-1 la-lg align-middle mr-0"></i> Reviews</a>
                              <a class=" dropdown-item  text-danger border-bottom py-2 text-nowrap"
                                (click)="remove(user.id)">
                                <i class="las la-trash mb-1 la-lg align-middle mr-0"></i> Delete</a>
                              </div>
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  }
                  @if (loading) {
                    <tbody>
                      @for (q of loaders; track q; let qi = $index) {
                        <tr class="client">
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{ width:'80px', height: '60px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                          <td>
                            <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                          </td>
                        </tr>
                      }
                    </tbody>
                  }
                </table>
                @if (!loading && !users?.length) {
                  <div class="d-flex align-items-center justify-content-center py-5">
                    No entities found
                  </div>
                }
                <div class="float-right mt-3">
                  <pagination-controls (pageChange)="pageChange($event)"></pagination-controls>
                </div>
              </div>
            </div>
          </div>
        </div>
